const scrollToTopButton = document.getElementById('scroll-to-top');
const rootElement = document.documentElement;

function scrollToTop() {
  rootElement.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

function displayButton() {
  if (window.pageYOffset >= 600) {
    scrollToTopButton.style.opacity = '1';
  } else {
    scrollToTopButton.style.opacity = '0';
  }
}

export default function SetupScrollToTop() {
  if (scrollToTopButton) {
    scrollToTopButton.addEventListener('click', scrollToTop);
    window.addEventListener('scroll', displayButton);
  }
}
